export enum CONTEXT_ATTRIBUTE {
  APPOINTMENT_FILTER = 'appointmentFilter',
  INITIAL_DATE = 'initialDate',
  SIDEBAR_CONTEXT = 'sideBarContext',
  APPOINTMENT_DETAIL = 'appointmentDetail'
}